<template>
    <div v-show="show" v-bind:class="{'alert alert-success' : type == 'success', 'alert alert-info' : type == 'info', 'alert alert-danger' : type == 'error'}" role="alert">
        
        <button type="button" class="close" @click="hide">
            <i class="fas fa-times-circle"></i>
        </button>
        {{ body }}
    </div>
</template>
    
<script>
    export default {
        props: ['message'],
        data() {
            return {
                show : false,
                body : '',
                type: '',
                successClass: 'alert alert-success',
                errorClass: 'alert alert-success'
            }
        },
        created() {
            if(this.message) {
                this.flash(this.message,this.type)
            }
            window.events.$on('flash',(message,type) => this.flash(message,type))
        },
        methods: {
            flash(message,type) {
            console.log(message,type);
                this.show = true
                this.body = message
                this.type = type
   
                // setTimeout(() => {
                //     this.hide()
                // },3000)
            },
            hide() {
                this.show = false
            }
        }
    }
</script>